import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.GetContractsForDocuSign.IRequest;
type Params = Api.Core.Contract.GetContractsForDocuSign.IParams;
type Response = Api.Core.Contract.GetContractsForDocuSign.IResponse;
type Headers = Api.Core.Contract.GetContractsForDocuSign.IHeaders;
const url = '/api/Sales/Contract/GetContractsForDocuSign/:signingType';
export default async function contractGetContractsForDocuSignApi(
  params: Params,
  query?: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { signingType: params.singingType }, query),
    headers: getDefaultHeaders(),
  });
}
